export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=4035d65ef7bd451bb8ccac16f9b5e8b9c9988fe1f9&name=revalidateCommunity!'